import React from 'react';
import View from './View';

const SystemEdit = (props) => {
  return (
    <>
      <View {...props} isEditMode />
    </>
  );
};

export default SystemEdit;
